<template>
    <div class="wlx-user-manager-wrapper">
        <div class="add-partner-enterprise-head clearfix">
            <div class="top-page-top fl">
                <span class="sp-top-text">单位管理</span>
            </div>
            <div class="fr btn-right">
                <el-form :inline="true" size="small">
                    <el-form-item>
                        <el-input v-model="userName" placeholder="请输入单位名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="getAllUserList()">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addSchool">添加</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <el-table :data="schoolList">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column prop="schoolName" label="单位名称"></el-table-column>
            <el-table-column prop="schoolType" label="单位类型"></el-table-column>
            <!-- <el-table-column prop="sex" label="性别">
            <template slot-scope="scope">
             <span v-if="scope.row.sex == 0">男</span>
             <span v-if="scope.row.sex == 1">女</span>
             </template>
          </el-table-column> -->
            <el-table-column prop="schoolCode" label="单位代码"></el-table-column>
            <el-table-column prop="contactsName" label="联系人姓名"></el-table-column>
            <el-table-column prop="schoolProvince" label="单位所在省"></el-table-column>
            <el-table-column prop="schoolCity" label="单位所在市"></el-table-column>
            <el-table-column prop="mobile" label="联系人手机号" v-if="userInfo.isSys"></el-table-column>
            <el-table-column prop="isDisable" label="是否停用">
                <template slot-scope="scope">
                    <span v-if="scope.row.isDisable == 0">在用</span>
                    <span v-else-if="scope.row.isDisable == 1">停用</span>
                </template>
            </el-table-column>
            <el-table-column prop="dateCreated" label="创建时间"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="修改" placement="top">
                        <el-button icon="el-icon-edit" size="mini" type="primary" @click="editSchool(scope.row)"></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="删除" placement="top">
                        <el-button icon="el-icon-delete" size="mini" type="danger" @click="deleteSchool(scope.row.id)"></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <div class="u-page-con">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="onPageChangeHandler"
                :current-page="page"
                :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                v-show="totalCount > 0"
                style="text-align: center;"
            ></el-pagination>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" append-to-body width="50%">
            <!-- <span style="color: red;font-size: 15px;">默认账号后六位</span>
            <div>
                <el-input v-model="newPassword" placeholder="请输入新密码" clearable></el-input>
            </div> -->
            <el-form ref="ruleForm" label-width="160px">
                <el-form-item label="单位名称" prop="title">
                    <el-input v-model="form.schoolName"></el-input>
                </el-form-item>
                <el-form-item label="单位类型" style="80px">
                    <el-radio-group v-model="form.schoolType">
                        <el-radio label="中职">中职</el-radio>
                        <el-radio label="高职">高职</el-radio>
                        <el-radio label="本科">本科</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="单位代码">
                    <el-input v-model="form.schoolCode"></el-input>
                </el-form-item>
                <el-form-item label="单位所在省份">
                    <!-- <el-input v-model="form.schoolProvince"></el-input> -->
                    <el-select v-model="form.schoolProvince" placeholder="请选择" @change="provinceChange">
                        <el-option
                            v-for="item in provinceList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="单位所在城市">
                    <!-- <el-input v-model="form.schoolCity"></el-input> -->
                    <el-select v-model="form.schoolCity" placeholder="请选择">
                        <el-option
                            v-for="item in cityList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="单位联系人">
                    <el-input v-model="form.contactsName"></el-input>
                </el-form-item>
                <el-form-item label="单位联系人手机号">
                    <el-input v-model="form.mobile"></el-input>
                </el-form-item>
                <el-form-item label="是否停用">
                    <el-radio-group v-model="form.isDisable">
                        <el-radio :label="0">在用</el-radio>
                        <el-radio :label="1">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>


            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addOrEditSchool()">确 定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
export default {
    data() {
        return {
            schoolName:"",
            page: 1,
            pageSize: 10,
            totalCount: 0,
            siteList: [],
            dialogVisible: false,
            userName: "",
            displayName: "",
            newPassword: "",
            id: "",
            schoolId: "",
            schoolList:[],
            dialogTitle:"",
            form:{
                id:"",
                schoolName:"",
                schoolType:"",
                schoolCode:"",
                contactsName:"",
                schoolProvince:"",
                schoolCity:"",
                mobile:"",
                isDisable:0
            },
            provinceList:[],
            cityList:[]
        };
    },
    components: {},
    computed: {
        userInfo() {
            return this.$store.state.auth;
        }
    },
    created() {
        this.getSchoolList();
        this.getAllProvinceList();
    },
    methods: {
        getSchoolList(){
            var that = this;
            this.$http.post("/api/XOrg/SchoolManager/getSchoolList",{
                schoolName:this.schoolName,
                page:this.page,
                pageSize:this.pageSize
            }).then(function(rst) {
                if (rst.code > 0) {
                    that.schoolList = rst.list;
                    that.page = rst.pagination.pageIndex;
                    that.pageSize = rst.pagination.pageSize;
                    that.totalCount = rst.pagination.totalCount;
                }
            });

        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getSchoolList();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getSchoolList();
        },
        addSchool(){
            this.dialogTitle = "添加";
            this.form.id = "";
            this.form.schoolName = "";
            this.form.schoolType = "";
            this.form.schoolCode = "";
            this.form.contactsName = "";
            this.form.schoolProvince = "";
            this.form.schoolCity = "";
            this.form.mobile = "";
            this.form.isDisable = 0;
            this.dialogVisible = true;
        },
        editSchool(row){
            this.dialogTitle = "修改";
            this.form.id = row.id;
            this.form.schoolName = row.schoolName;
            this.form.schoolType = row.schoolType;
            this.form.schoolCode = row.schoolCode;
            this.form.contactsName = row.contactsName;
            this.form.schoolProvince = row.schoolProvinceId;
            this.form.schoolCity = row.schoolCityId;
            this.form.mobile = row.mobile;
            this.form.isDisable = row.isDisable;
            this.dialogVisible = true;
        },
        addOrEditSchool(){
            this.$http
            .post("/api/XOrg/SchoolManager/addOrEditSchool", {
                schoolId:  this.form.id,
                schoolName:this.form.schoolName,
                schoolType:this.form.schoolType,
                schoolCode:this.form.schoolCode,
                contactsName:this.form.contactsName,
                schoolProvinceId:this.form.schoolProvince,
                schoolCityId:this.form.schoolCity,
                mobile:this.form.mobile,
                isDisable:this.form.isDisable
            })
            .then((rst) => {
                if (rst.code > 0) {
                    this.$message.success(rst.msg);
                    this.getSchoolList();
                    this.dialogVisible = false;
                } else {
                    this.$message.warning(rst.msg);
                }
            });
        },
        deleteSchool(id) {
            this.$confirm("此操作将删除所选单位, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .post("/api/XOrg/SchoolManager/deleteSchools", {
                            ids: id,
                        })
                        .then((rst) => {
                            if (rst.code > 0) {
                                this.$message.success(rst.msg);
                                this.getSchoolList();
                            } else {
                                this.$message.warning(rst.msg);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        provinceChange(){
            this.form.schoolCity = "";
            this.getCityList();
        },
        getAllProvinceList(){
            this.$http
                .post("/api/XOrg/District/getProvinceList", {})
                .then((rst) => {
                    if (rst.code > 0) {
                        this.provinceList = rst.province;
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
        },
        getCityList(){
            this.$http
                .post("/api/XOrg/District/getCityList", {
                    province: this.form.schoolProvince
                })
                .then((rst) => {
                    if (rst.code > 0) {
                        this.cityList = rst.cityList;
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });

        }
    },
};
</script>
<style lang="scss">
.wlx-user-manager-wrapper {
    background: #fff;
    padding-bottom: 20px;
    .add-partner-enterprise-head {
        border-bottom: 1px solid #F0F0F0;
        height: 60px;
        .add-banner-btn,
        .delete-banner-btn {
            margin-top: 13px;
        }
        .delete-banner-btn {
            margin-right: 62px;
        }
        .top-page-top{
            border: none;
        }
    }
    .banner-page-con {
        padding: 20px 0;
        text-align: center;
    }
    .el-table thead{
        color: #05243D;
    }
    .btn-right{
        margin-right: 30px;
        margin-top: 14px;
    }
}
</style>
